import { HttpParams } from '@angular/common/http';

export class ReportFilter {

    id: number | undefined;

    company: number | undefined;
    parameter: string | undefined;
    customer : number | undefined;
    since : string | null;
    until : string | null;
    
	constructor(filter?: ReportFilter) {
		if (filter) {
          
            this.id = filter.id;
            this.company = filter.company;
            this.parameter = filter.parameter;
            this.customer = filter.customer;
            this.since = filter.since;
            this.until = filter.until;

		}
	}

	getHttpParams(httpParams = new HttpParams()): HttpParams {
    
  
        if (this.customer) {
			httpParams = httpParams.set('customer', this.customer.toString());
        }
    
        if (this.id) {
			httpParams = httpParams.set('id', this.id.toString());
        }
      
        if (this.company) {
			httpParams = httpParams.set('company', this.company.toString());
        }
        if (this.parameter) {
			httpParams = httpParams.set('parameter', this.parameter);
        }

        if (this.since) {
            httpParams = httpParams.set('since', this.since);
        }
        if (this.until) {
            httpParams = httpParams.set('until', this.until);
        }

     
		return httpParams;
	}
}